import Cookies from 'js-cookie';

import { StorageInterface } from 'types/storage';

export const getMainDomain = (domain: Pick<URL, 'hostname'>): string => {
  return domain.hostname.split('.').slice(-2).join('.');
};

export const getCookieDomain = (hostname: string): string => {
  const mainDomain = getMainDomain({ hostname });

  if (mainDomain.match(/femtasy\.\w+$/)) {
    return `.${mainDomain}`;
  }

  if (/\.workers\.dev$/.test(hostname)) {
    const parts = hostname.split('.');

    if (parts.length >= 4) {
      return `.${parts.slice(-3).join('.')}`;
    }
  }

  return '';
};

const domain = getCookieDomain(window.location.hostname);

const cookieStorage: StorageInterface = {
  getItem(key) {
    return Cookies.get(key) || null;
  },

  getItems(keys, mapFn = () => {}) {
    return keys.map((key) => this.getItem(key)).map(mapFn);
  },

  setItem(key, values, cookieAttributes: Cookies.CookieAttributes = {}) {
    return Cookies.set(key, values as string, {
      domain,
      expires: 365,
      ...cookieAttributes,
    });
  },

  removeItem(key) {
    return Cookies.remove(key, { domain });
  },
};

export default cookieStorage;
